// src/components/DynamicSetupWizard/Components/FieldMapper.tsx
import React from "react";
import { Row, Col, Card, Alert } from "reactstrap";
import Select from "react-select";
export type Option = { value: string; label: string };
export interface FieldMappingItem {
  form_field: Option;
  crm_field: Option | null;
}
interface FieldMapperProps {
  title: string;
  description?: string;
  mapping: FieldMappingItem[];
  fieldOptions: Option[];
  loading: boolean;
  error?: string | null;
  onChange: (index: number, crmField: Option | null) => void;
}
export default function FieldMapper({
  title, description, mapping,
  fieldOptions, loading, error, onChange
}: FieldMapperProps) {
  if (loading) {
    return (
      <>
        <h5 className="fw-bold">{title}</h5>
        {description && <p className="text-secondary mb-4">{description}</p>}
        <Row className="align-items-center g-4 mb-4">
          {mapping.map((_, idx) => (
            <React.Fragment key={idx}>
              <Col md={5}>
                <Card className="placeholder-glow shadow-sm rounded-3 p-3 text-center">
                  <span className="placeholder col-6" style={{height: '1rem'}}/>
                </Card>
              </Col>
              <Col md={2} className="text-center">
                <span className="placeholder col-1" style={{height: '1rem', display:'inline-block'}}/>
              </Col>
              <Col md={5}>
                <Card className="placeholder-glow shadow-sm rounded-3 p-3 text-center">
                  <span className="placeholder w-100" style={{height: '2.5rem', display:'block', borderRadius:'.25rem'}}/>
                </Card>
              </Col>
            </React.Fragment>
          ))}
        </Row>
      </>
    );
  }

  return (
    <>
      <h5 className="fw-bold">{title}</h5>
      {description && <p className="text-secondary mb-4">{description}</p>}
      <Row className="align-items-center g-4 mb-4">
        {mapping.map((m, i) => {
          const sel = m.crm_field;
          return (
            <React.Fragment key={i}>
              <Col md={5}>
                <Card className="shadow-sm rounded-3 p-3 text-center bg-light">
                  {m.form_field.label}
                </Card>
              </Col>
              <Col md={2} className="text-center">
                <i className="ri-arrow-right-line fs-3 text-primary" />
              </Col>
              <Col md={5}>
                <Select<Option, false>
                  options={fieldOptions}
                  value={sel}
                  onChange={(opt: Option | null) => onChange(i, opt)}
                  placeholder="Select field…"
                  className="shadow-sm"
                  isDisabled={!!error}
                />
              </Col>
            </React.Fragment>
          );
        })}
        {error && (
          <Col xs={12}>
            <Alert color="danger">{error}</Alert>
          </Col>
        )}
      </Row>
    </>
  );
}
